import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import CreatePost from './pages/CreatePost';
import PostDetail from './pages/PostDetail';
import Profile from './pages/Profile';
import AdminPanel from './pages/AdminPanel';
import SetLocation from './pages/SetLocation';
import ResetPassword from './pages/ResetPassword';
import SupportChatWidget from './components/SupportChatWidget';
import { Toaster } from './components/ui/sonner';
import '@/App.css';
import 'leaflet/dist/leaflet.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const AuthContext = React.createContext();

// Gate component: if user is logged in but has no location, force them to SetLocation
function RequireLocation({ user, children }) {
  if (user && !user.location) {
    return <Navigate to="/set-location" replace />;
  }
  return children;
}

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        setUser(res.data);
        setLoading(false);
      })
      .catch(() => {
        localStorage.removeItem('token');
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={user ? <Navigate to="/dashboard" /> : <Landing />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/set-location" element={user ? (user.location ? <Navigate to="/dashboard" /> : <SetLocation />) : <Navigate to="/" />} />
          <Route path="/dashboard" element={user ? <RequireLocation user={user}><Dashboard /></RequireLocation> : <Navigate to="/" />} />
          <Route path="/create" element={user ? <RequireLocation user={user}><CreatePost /></RequireLocation> : <Navigate to="/" />} />
          <Route path="/post/:id" element={user ? <RequireLocation user={user}><PostDetail /></RequireLocation> : <Navigate to="/" />} />
          <Route path="/profile" element={user ? <RequireLocation user={user}><Profile /></RequireLocation> : <Navigate to="/" />} />
          <Route path="/admin" element={user ? <RequireLocation user={user}><AdminPanel /></RequireLocation> : <Navigate to="/" />} />
        </Routes>
        <SupportChatWidget />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthContext.Provider>
  );
}

export default App;
